import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, useState } from 'react';
const PreviewImgModal = (props) => {
    return (
        <Modal
            open={props.modal_img}
            // onOk={hideModal}
            onCancel={e => props.set_modal_img(false)}
            footer={false}
            width={600}
            style={{ padding: '20px' }}
        >
            <Col span={24}>
                <Row justify={'center'}>
                    <Col>
                        <img width={'100%'} height={'auto'} src={props.img}></img>
                    </Col>
                </Row>
            </Col>
        </Modal>
    )
}
export default PreviewImgModal;